import { app } from '../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.license-management.invoices', {
        url: '/invoices',
        component: 'licenseInvoices',
        resolve: {
            invoices
        },
    });
}

/** @ngInject */
function invoices(LicenseManagementService, $stateParams) {
    return LicenseManagementService.getLicenseInvoices($stateParams.companyId);
}



// WEBPACK FOOTER //
// ./src/portal/states/company/license-management/invoices/license-invoices.state.js